/* eslint-disable no-undef */
import axios from 'axios'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import _ from 'lodash'

const translations = {
  lt: require('./lt/lt.json'),
  en: require('./en/en.json')
}

let storageLocale = localStorage.getItem('locale')

if (!storageLocale) localStorage.setItem('locale', 'lt')

window.locale = storageLocale || 'lt'

export const __ = (key, replace) => {
  let translation = translations[locale][key] ? translations[locale][key] : key

  if (replace) {
    _.each(replace, (value, key) => {
      translation = translation.replace(`:${key}`, value)
    })
  }

  return translation
}

Vue.prototype.__ = window.__ = __

Vue.directive('trans', (el, binding) => {
  if (typeof binding.value === 'string') {
    binding.value = {
      key: binding.value,
      params: null
    }
  }

  el.innerText = __(binding.value.key, binding.value.params)
})

axios.interceptors.request.use(function (config) {
  if (config.params) {

    switch(locale){
      case 'lt':
        config.params['culture'] = 'lt-LT';
        break;
      case 'en':
        config.params['culture'] = 'en-US';
        break;
    }
  

    return config
  }

  switch(locale){
    case 'lt':
      config.params = {
        culture:'lt-LT'
      } 
      break;
    case 'en':
      config.params = {
        culture:'en-US'
      }
      break;
  }
  

  return config
}, function (error) {
  return Promise.reject(error)
})

Vue.use(VeeValidate, {
  locale,
  dictionary: {
    lt: {
      custom: require('./lt/validation.json')
    },
    en: {
      custom: require('./en/validation.json')
    }
  }
})
